import { render, staticRenderFns } from "./districtDisStatics.vue?vue&type=template&id=612f9e77&scoped=true"
import script from "./districtDisStatics.vue?vue&type=script&lang=js"
export * from "./districtDisStatics.vue?vue&type=script&lang=js"
import style0 from "./districtDisStatics.vue?vue&type=style&index=0&id=612f9e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f9e77",
  null
  
)

export default component.exports